import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { FolderRedirectLoader } from '@confluence/folder/entry-points/FolderRedirectLoader.ts';
import { FolderContainerLoader } from '@confluence/folder';
import { fg } from '@confluence/feature-gating';

export const FolderViewRoute = ({ params: { contentId } }: RouteMatch) =>
	fg('confluence_cloud_folder_view') ? (
		<FolderContainerLoader contentId={contentId} />
	) : (
		<FolderRedirectLoader contentId={contentId} />
	);

FolderViewRoute.NAVIGATION_PARAMS = ({
	name: routeName,
	params: { contentId, spaceKey },
}: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'folderScreen',
			id: contentId,
			attributes: {
				contentId,
			},
		},
		pageState: {
			contentId,
			spaceKey,
			contentType: 'folder',
			routeName,
		},
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
		isViewPage: true,
	},
});
